<template>
  <div style="height: 100%">
    <v-card
      class="d-flex flex-column"
      min-height="100%"
    >
      <v-card-title>
        <v-col class="pa-0">
          <v-tabs
            v-if="chartData.length"
            v-model="currentTab"
          >
            <v-tab
              v-for="(tab, tabKey) in chartData"
              :key="tabKey"
            >
              {{ tab.tabTitle }}
            </v-tab>
          </v-tabs>
          <span class="text--disabled" v-else>Please choose the period</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" lg="4" class="d-flex align-top pa-0">
          <RangeDatePickerMenu
            v-model="dateRange"
            label="Period"
            showButtons
            @onOkClick="getMetricsData"
          />
          <v-btn
            :disabled="dateRange.length < 2"
            color="primary"
            class="ml-4"
            small
            @click="getMetricsData"
          >
            Show
          </v-btn>
        </v-col>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-4" v-if="chartData.length" :key="currentTab">
        <v-row>
          <v-col cols="12" md="6"
            v-for="(chart, chartKey) in chartData[currentTab].charts"
            :key="chartKey"
          >
            <MetricChart
              :chartTitle="chart.chartTitle"
              :chartData="chart.chart"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'MetricsChartsByProject',
  components: {
    MetricChart: () => import('@/components/metrics/MetricChart'),
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue')
  },
  data () {
    return {
      search: '',
      dates: [],
      datePickerMenu: false,
      currentTab: 0,
      chartData: []
    }
  },
  computed: {
    dateRange: {
      get () {
        return this.dates
      },
      set (value) {
        this.dates = value.sort((a, b) => {
          const dA = new Date(a)
          const dB = new Date(b)
          if (+dA > +dB) return 1
          if (+dA < +dB) return -1
          return 0
        })
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    selectedProject () {
      return this.$store.getters.getSelectedProject
    }
  },
  methods: {
    getMetricsData () {
      this.chartData = []
      this.axios.get(`/api/metrics/get_metrics_value_for_charts/${this.selectedProject}/${this.dates[0]}/${this.dates[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.chartData = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
